import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'variantRelated';

export const variantRelatedActions = makeActions(
  MODEL_NAME,
  'id',
  'product-variants',
);

export const getAllVariantRelated = variantRelatedActions.getAll;
export const editVariantRelated = variantRelatedActions.edit;
export const createVariantRelated = variantRelatedActions.create;
export const getByIdVariantRelated = variantRelatedActions.getDataById;
